const tabs = {
  category: "category",
  attributes: "attributes",
};

const modes = { view: "view", edit: "edit", new: "new" };

export { tabs, modes };
